angular.module(APP_ID).run(['$templateCache', function($templateCache) {
  /** IMPORTANT*: PLACEHOLDER ONLY - DO NOT EDIT! Will be auto-injected with templates when building production-ready code by Grunt! */
}]);
